import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Markdown } from '../components/Markdown/Markdown';
import { resolveTermsContent } from '../content/legal/resolveLegalContent';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  const { i18n, t } = useTranslation('legal');
  const termsContent = resolveTermsContent(i18n.language);

  return (
    <div className="pageContainer">
      <h1 className="pageTitle">{t('termsTitle')}</h1>
      <div className="pageSection">
        <Markdown content={termsContent} />
      </div>
    </div>
  );
}
